export enum discountSettingPaths {
  id = '/:id',
  name = '/:name'
}
